import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestConsentAllGet = {
    path: "/consent/all",
    method: RouteHttpVerb.GET
};
